export class ledgerData {
    BillDate : String;
    BillAmount : Number;
    Amount : Number;
    Acode : String;
    UnderGroup : String;
    Rate: Number;
}